module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"averagedinertime":"Average diner time"},"es":{"averagedinertime":"Tiempo medio del comensal"}}')
  delete Component.options._Ctor
}
